import { useEffect, useState } from 'react';
import apiClient from '../../lib/api';

type Mode = 'LEGGERA' | 'PIANIFICATA' | 'RIGOROSA';
type Resolved = { effective: Mode; configured: Mode | 'AUTO'; auto: boolean };

const COLOR: Record<Mode, string> = {
  LEGGERA: 'bg-emerald-100 text-emerald-700 border-emerald-300',
  PIANIFICATA: 'bg-amber-100 text-amber-700 border-amber-300',
  RIGOROSA: 'bg-rose-100 text-rose-700 border-rose-300',
};

const LABEL: Record<Mode, string> = {
  LEGGERA: 'Modalità leggera',
  PIANIFICATA: 'Modalità pianificata',
  RIGOROSA: 'Modalità rigorosa',
};

export default function AvailabilityModeBadge() {
  const [data, setData] = useState<Resolved | null>(null);
  useEffect(() => {
    apiClient.get<Resolved>('/calendar/availability-mode').then(r => {
      if (r.success && r.data) setData(r.data);
    }).catch(() => {});
  }, []);
  if (!data) return null;
  const m = data.effective;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${COLOR[m]}`}
      title={data.auto ? `Auto-rilevata: ${m}` : `Configurata: ${m}`}
    >
      {LABEL[m]}{data.auto ? ' · auto' : ''}
    </span>
  );
}
